import React from 'react';
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import { CometChat } from '@cometchat-pro/chat';

import Button from '../../../../../Button';

import { CometChatUserList } from '../../Users';
import { CometChatGroupList } from '../../Groups';
import { CometChatConversationList } from '../../Chats';
import { CometChatUserProfile } from '../../UserProfile';
import { NewMessageModal } from '../../Modals/NewMessageModal';

import * as enums from '../../../util/enums.js';
import { CometChatContext } from '../../../util/CometChatContext';

import Translator from '../../../resources/localization/translator';
import { theme } from '../../../resources/theme';
import tabs from '../../../resources/tabs.json';

import { useUniversalMessagingContext } from '../../../../../../providers/UniversalMessagingProvider';

import Close from '../../../../../../icons/Close';
import MessagePencil from '../../../../../../icons/MessagePencil';

import { segmentTracking } from '../../../../../../services/utilities';

import {
  navbarContainer,
  navbarStyle,
  tabTextStyle,
  tabContainerStyle,
  newMessageButtonStyle,
  pencilStyle,
} from './style';

class CometChatNavBarClass extends React.Component {
  static contextType = CometChatContext;

  tabListKeys = [];
  constructor(props) {
    super(props);

    this.state = {
      activeTab: null,
      tabList: [],
      newMessageModal: false,
      enableSearchUser: false,
      newMessagesUniversalMessaging: false,
      userlist: [],
      decoratorMessage: Translator.translate('LOADING', props.lang),
    };
    CometChat.getLoggedinUser()
      .then((user) => (this.loggedInUser = user))
      .catch((error) => {
        console.error(error);
      });
  }

  componentDidMount() {
    let tabList = this.context.UIKitSettings.tabs;

    tabList.forEach((tabName) => {
      for (const t in tabs) {
        if (tabName === tabs[t]) {
          this.tabListKeys.push(t);
        }
      }
    });

    this.getFilteredTabs().then((filteredTabs) => {
      this.props.onTabChange(filteredTabs[0]);
      this.setState({ tabList: filteredTabs, activeTab: filteredTabs[0] });
    });
  }

  getFilteredTabs = () => {
    return new Promise((resolve) => {
      const filteredTabs = [];
      const promises = [
        this.enableChats(),
        this.enableUsers(),
        this.enableGroups(),
        this.enableSettings(),
      ];
      Promise.allSettled(promises).then((results) => {
        this.tabListKeys.forEach((eachTabKey) => {
          results.forEach((result) => {
            const tabKey = result.value[0];
            const tabEnabled = result.value[1];

            if (eachTabKey === tabKey && tabEnabled === true) {
              filteredTabs.push(eachTabKey);
            }
          });
        });
        resolve(filteredTabs);
      });
    });
  };

  enableChats = () => {
    return new Promise((resolve) => {
      this.context.FeatureRestriction.isRecentChatListEnabled()
        .then((response) => resolve(['SIDEBAR_CHATS', response]))
        .catch((error) => resolve(['SIDEBAR_CHATS', false]));
    });
  };

  enableUsers = () => {
    return new Promise((resolve) => {
      this.context.FeatureRestriction.isUserListEnabled()
        .then((response) => resolve(['SIDEBAR_USERS', response]))
        .catch((error) => resolve(['SIDEBAR_USERS', false]));
    });
  };

  enableGroups = () => {
    return new Promise((resolve) => {
      this.context.FeatureRestriction.isGroupListEnabled()
        .then((response) => resolve(['SIDEBAR_GROUPS', response]))
        .catch((error) => resolve(['SIDEBAR_GROUPS', false]));
    });
  };

  enableSettings = () => {
    return new Promise((resolve) => {
      this.context.FeatureRestriction.isUserSettingsEnabled()
        .then((response) => resolve(['SIDEBAR_MOREINFO', response]))
        .catch((error) => resolve(['SIDEBAR_MOREINFO', false]));
    });
  };

  tabChanged = (tab) => {
    this.setState({ activeTab: tab });
    this.props.onTabChange(tab);

    this.context.setItem({});
  };

  getActiveTab = () => {
    switch (this.state.activeTab) {
      case 'SIDEBAR_USERS':
        return (
          <CometChatUserList
            theme={this.props.theme}
            lang={this.context.language}
            _parent="unified"
            actionGenerated={this.props.actionGenerated}
            tabNavigation={this.getTabList}
            newMessageModal={this.getNewMessageButton}
            onItemClick={(item, type) =>
              this.props.actionGenerated(
                enums.ACTIONS['ITEM_CLICKED'],
                type,
                item,
              )
            }
          />
        );
      case 'SIDEBAR_CALLS':
        return null;
      case 'SIDEBAR_CHATS':
        return (
          <CometChatConversationList
            theme={this.props.theme}
            lang={this.context.language}
            _parent="unified"
            actionGenerated={this.props.actionGenerated}
            tabNavigation={this.getTabList}
            newMessageModal={this.getNewMessageButton}
            onItemClick={(item, type, tags, conversationId) => {
              this.props.actionGenerated(
                enums.ACTIONS['ITEM_CLICKED'],
                type,
                item,
                tags,
                conversationId,
              );
            }}
          />
        );
      case 'SIDEBAR_GROUPS':
        return (
          <CometChatGroupList
            theme={this.props.theme}
            lang={this.context.language}
            _parent="unified"
            actionGenerated={this.props.actionGenerated}
            onItemClick={(item, type) =>
              this.props.actionGenerated(
                enums.ACTIONS['ITEM_CLICKED'],
                type,
                item,
              )
            }
          />
        );
      case 'SIDEBAR_MOREINFO':
        return (
          <CometChatUserProfile
            theme={this.props.theme}
            lang={this.context.language}
            isFromUniversalMessaging={this.props.isFromUniversalMessaging}
            onItemClick={(item, type) =>
              this.props.actionGenerated(
                enums.ACTIONS['ITEM_CLICKED'],
                type,
                item,
              )
            }
          />
        );
      default:
        return null;
    }
  };

  getNewMessageButton = (hasActiveRenters) => {
    if (this.props.isFromUniversalMessaging) {
      if (!hasActiveRenters)
        return (
          <div
            css={pencilStyle()}
            onClick={() => {
              this.props.toggleChat();
            }}
          >
            <Close color="#033A6D" />
          </div>
        );
      return (
        <div
          css={pencilStyle()}
          onClick={() => {
            segmentTracking('pen_icon clicked', {
              location: 'Chat Bubble',
            });
            this.setState({ newMessageModal: true });
          }}
        >
          <MessagePencil />
        </div>
      );
    }
    if (!hasActiveRenters) return null;
    return (
      <Button
        secondary
        onClick={() => {
          segmentTracking('new message clicked', {
            location: 'Messages',
          });
          this.setState({ newMessageModal: true });
        }}
        css={newMessageButtonStyle()}
      >
        New Message
      </Button>
    );
  };

  getTabList = () => {
    const chatsTabActive =
      this.state.activeTab === 'SIDEBAR_CHATS' ? true : false;
    const userTabActive =
      this.state.activeTab === 'SIDEBAR_USERS' ? true : false;
    const groupsTabActive =
      this.state.activeTab === 'SIDEBAR_GROUPS' ? true : false;
    const moreTabActive =
      this.state.activeTab === 'SIDEBAR_MOREINFO' ? true : false;

    const tabList = [...this.state.tabList];

    const isOwner = this.loggedInUser?.role === 'owner';

    if (!isOwner) {
      return null;
    }

    const tabs = tabList.map((tab) => {
      switch (tab) {
        case 'SIDEBAR_CHATS':
          return (
            <div
              key={tab}
              css={tabContainerStyle(chatsTabActive)}
              className="navbar__item"
              onClick={() => {
                segmentTracking('chats tab clicked', {
                  location: 'Messages',
                });
                this.tabChanged('SIDEBAR_CHATS');
              }}
            >
              <div css={tabTextStyle()} className="item__label">
                {Translator.translate('CHATS', this.context.language)}
              </div>
            </div>
          );
        case 'SIDEBAR_USERS':
          return (
            <div
              key={tab}
              css={tabContainerStyle(userTabActive)}
              className="navbar__item"
              onClick={() => {
                segmentTracking(
                  `${isOwner ? 'renters' : 'owners'} tab clicked`,
                  {
                    location: 'Messages',
                  },
                );
                this.tabChanged('SIDEBAR_USERS');
              }}
            >
              <div css={tabTextStyle()} className="item__label">
                {Translator.translate(
                  isOwner ? 'Renters' : 'Owners',
                  this.context.language,
                )}
              </div>
            </div>
          );
        case 'SIDEBAR_GROUPS':
          return (
            <div
              key={tab}
              css={tabContainerStyle(groupsTabActive)}
              className="navbar__item"
              onClick={() => this.tabChanged('SIDEBAR_GROUPS')}
            >
              <div css={tabTextStyle()} className="item__label">
                {Translator.translate('GROUPS', this.context.language)}
              </div>
            </div>
          );
        case 'SIDEBAR_MOREINFO':
          return (
            <div
              key={tab}
              css={tabContainerStyle(moreTabActive)}
              className="navbar__item"
              onClick={() => this.tabChanged('SIDEBAR_MOREINFO')}
            >
              <div css={tabTextStyle()} className="item__label">
                {Translator.translate('MORE', this.context.language)}
              </div>
            </div>
          );
        default:
          return null;
      }
    });

    return (
      <div
        css={navbarContainer(this.props.isFromUniversalMessaging)}
        className="header__navbar_container"
      >
        <div css={navbarStyle()} className="header__navbar">
          {this.props.isFromUniversalMessaging ? null : tabs}
        </div>
      </div>
    );
  };

  render() {
    return (
      <React.Fragment>
        {this.props.isFromUniversalMessaging ? (
          <CometChatConversationList
            theme={this.props.theme}
            lang={this.context.language}
            _parent="unified"
            actionGenerated={this.props.actionGenerated}
            tabNavigation={this.getTabList}
            isFromUniversalMessaging={this.props.isFromUniversalMessaging}
            newMessageModal={this.getNewMessageButton}
            initialChatId={this.props.initialChatId}
            onItemClick={(item, type, tags, conversationId) => {
              this.props.actionGenerated(
                enums.ACTIONS['ITEM_CLICKED'],
                type,
                item,
                tags,
                conversationId,
              );
            }}
          />
        ) : (
          this.getActiveTab()
        )}
        {this.state.newMessageModal && (
          <NewMessageModal
            open={true}
            isFromUniversalMessaging={this.props.isFromUniversalMessaging}
            onClose={() => this.setState({ newMessageModal: false })}
            onUserSelect={(user) =>
              this.props.actionGenerated(
                enums.ACTIONS['ITEM_CLICKED'],
                CometChat.ACTION_TYPE.TYPE_USER,
                user,
              )
            }
          />
        )}
      </React.Fragment>
    );
  }
}

export const CometChatNavBar = (props) => {
  const { toggleChat } = useUniversalMessagingContext();
  return <CometChatNavBarClass {...props} toggleChat={toggleChat} />;
};

// Specifies the default values for props:
CometChatNavBar.defaultProps = {
  theme: theme,
};

CometChatNavBar.propTypes = {
  theme: PropTypes.object,
  onTabChange: PropTypes.func,
};
